export default __webpack_public_path__ + "static/media/companyInfo_color.9a02f541.svg";